import { isInternetExplorer } from '../utils/browser-detection';
export var LINK_API_POLLING_INTERVAL = isInternetExplorer() ? 2 : 0.5;
export var IRIS_FLUSH_INTERVAL = isInternetExplorer() ? 5000 : 500;
